import { useEffect, useState } from 'react'
import { subscribeToMatch } from '@/services/firebase'
import { useToast } from '@chakra-ui/react'

export function useTennisMatchData(matchId: string) {
  const [state, setState] = useState<any>({})
  const toast = useToast()

  useEffect(() => {
    const unsub = subscribeToMatch(matchId, (data) => {
      // Check if match was deleted
      if (!data) {
        // Extract court number from the matchId or state if available
        const courtNumber = state.courtNumber || 'unknown'
        toast({
          title: 'Match Deleted',
          description: `The match has been deleted - This court #${courtNumber} has been used to start a new match on another screen.`,
          status: 'warning',
          duration: 3000,
          isClosable: true,
        })
        // Redirect to landing page after a short delay
        setTimeout(() => {
          window.location.href = '/'
        }, 15000)
        return
      }
      
      setState(data)
    })
    return () => unsub()
  }, [matchId, toast])

  // Extract tiebreak data from the state
  const tiebreak = state.tiebreak || null

  return {
    ...state,
    tiebreak
  }
} 